import styled from '@emotion/styled';

export const CalendarTitle = styled.div`
  color: #000000;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  margin: 16px 0;
`;
